export const loadGoogleAutoCompleteApi = () => {
    const sourceUrl =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyALGzBGoP7_VkRkA-tZVW_KBY-X2EH938c&loading=async&libraries=places";
    const scripts = document.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.indexOf(sourceUrl) === 0) {
            return scripts[i];
        }
    }

    const googleAutocompleteScript = document.createElement("script");
    googleAutocompleteScript.src = sourceUrl;
    googleAutocompleteScript.async = true;
    googleAutocompleteScript.defer = true;
    window.document.body.appendChild(googleAutocompleteScript);

    return googleAutocompleteScript;
};
